import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectIssueNavigatorRoute: InvariantJiraRoute = {
	name: 'issue-navigator',
	path: '/projects/:projectKey/issues/:issueKey?',
};
